import React from 'react';
import { Home, Building2, Trees, Hammer, CheckCircle2, ArrowRight, Phone } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './Animations';
export const Services = () => {
  const categories = [{
    icon: Home,
    title: 'Residential',
    tagline: 'Home & Garage Cleanouts',
    items: ['Old furniture & sofas', 'Appliances (fridges, washers, dryers)', 'Mattresses & bed frames', 'Garage cleanouts', 'Estate cleanouts', 'Attic & basement junk']
  }, {
    icon: Building2,
    title: 'Commercial',
    tagline: 'Offices, Warehouses & Retail',
    items: ['Office furniture & equipment', 'Commercial junk & debris', 'Warehouse cleanouts', 'Retail space junk', 'Restaurant equipment', 'Property management cleanouts']
  }, {
    icon: Trees,
    title: 'Yard & Outdoor',
    tagline: 'Landscape & Seasonal Cleanup',
    items: ['Leaf & branch removal', 'Overgrown shrub clearing', 'Weed removal & cleanup', 'Seasonal yard cleanup', 'Garden & landscape debris', 'Dirt, rock & soil removal']
  }];
  const extras = ['Demolition Removal', 'Construction Debris', 'Yard & Green Waste', 'Full Property Cleanouts', 'Hot Tub Removal', 'Shed Tear-Downs'];
  return <section id="services" className="py-20 md:py-24 bg-white relative overflow-hidden" data-id="element-505">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-brand-red/5 rounded-full blur-3xl pointer-events-none" data-id="element-506" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-507">
        <FadeIn className="text-center max-w-2xl mx-auto mb-14" data-id="element-508">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-red mb-4" data-id="element-509">
            Our Services
          </div>
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase text-brand-black mb-5 leading-tight" data-id="element-510">
            We Remove <span className="text-brand-red" data-id="element-511">It All</span>
          </h2>
          <p className="text-zinc-600 text-lg" data-id="element-512">
            No exceptions. No excuses. If it's taking up space and you want it
            gone — we take it. From a single couch to an entire property.
          </p>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-14" data-id="element-513">
          {categories.map((cat, idx) => <StaggerItem key={idx} className="group bg-white rounded-sm border-2 border-zinc-100 hover:border-brand-red transition-all hover:shadow-2xl hover:-translate-y-1 duration-300 overflow-hidden relative" data-id="element-514">
              {/* Header bar */}
              <div className="bg-brand-black text-white p-6 relative overflow-hidden" data-id="element-515">
                <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/20 rounded-full blur-2xl group-hover:bg-brand-red/40 transition-colors" data-id="element-516"></div>
                <div className="relative flex items-center gap-4" data-id="element-517">
                  <div className="w-14 h-14 bg-brand-red flex items-center justify-center rounded-sm shrink-0" data-id="element-518">
                    <cat.icon className="w-7 h-7 text-white" data-id="element-519" />
                  </div>
                  <div data-id="element-520">
                    <h3 className="font-oswald text-2xl md:text-3xl font-bold uppercase leading-tight" data-id="element-521">
                      {cat.title}
                    </h3>
                    <p className="text-xs uppercase tracking-wider text-zinc-400 font-semibold mt-1" data-id="element-522">
                      {cat.tagline}
                    </p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-7" data-id="element-523">
                <ul className="space-y-3.5 mb-6" data-id="element-524">
                  {cat.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-525">
                      <CheckCircle2 className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-526" />
                      <span className="text-zinc-700 font-medium text-[15px]" data-id="element-527">
                        {item}
                      </span>
                    </li>)}
                </ul>
                <a href="tel:+15597709442" className="flex items-center justify-between font-oswald text-sm font-bold uppercase tracking-wide text-brand-black hover:text-brand-red transition-colors pt-4 border-t border-zinc-100 group/link" data-id="element-528">
                  Get a Free Quote
                  <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" data-id="element-529" />
                </a>
              </div>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn data-id="element-530">
          <div className="bg-brand-black text-white p-8 md:p-10 rounded-sm relative overflow-hidden" data-id="element-531">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red/10 rounded-full blur-3xl" data-id="element-532"></div>
            <div className="relative grid md:grid-cols-12 gap-6 items-center" data-id="element-533">
              <div className="md:col-span-3 flex items-center gap-3" data-id="element-534">
                <div className="w-12 h-12 bg-brand-red flex items-center justify-center rounded-sm" data-id="element-535">
                  <Hammer className="w-6 h-6 text-white" data-id="element-536" />
                </div>
                <div data-id="element-537">
                  <p className="text-xs uppercase tracking-wider text-zinc-400 font-semibold" data-id="element-538">
                    We Also
                  </p>
                  <p className="font-oswald text-2xl font-bold uppercase leading-tight" data-id="element-539">
                    Handle
                  </p>
                </div>
              </div>
              <div className="md:col-span-7 flex flex-wrap gap-2" data-id="element-540">
                {extras.map((extra, idx) => <span key={idx} className="bg-white/5 hover:bg-brand-red border border-white/10 hover:border-brand-red px-4 py-2 rounded-sm text-sm font-semibold uppercase tracking-wide transition-colors cursor-default" data-id="element-541">
                    {extra}
                  </span>)}
              </div>
              <a href="tel:+15597709442" className="md:col-span-2 flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-darkred px-5 py-3 rounded-sm font-bold uppercase text-sm tracking-wide transition-colors" data-id="element-542">
                <Phone className="w-4 h-4" data-id="element-543" />
                Call Now
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};